import React from "react";
import PropTypes from "prop-types";
import { Link, Route } from "react-router-dom";

const renderNavLink = (to, className, isActive, { externalUrl, children }) => (
  <li className={`${isActive ? `${className}--active` : ""}`}>
    {externalUrl ? <a href={externalUrl}>{children}</a> : <Link to={to}>{children}</Link>}
  </li>
);

const NavLink = ({
  to,
  className = "apl-header__nav-item",
  renderItem = renderNavLink,
  ...props
}) => (
  <Route path={props.externalUrl || to}>
    {({ match }) => renderItem(to, className, match, props)}
  </Route>
);

NavLink.propTypes = {
  to: PropTypes.string,
  externalUrl: PropTypes.string,
  className: PropTypes.string,
  renderItem: PropTypes.func,
  children: PropTypes.node.isRequired,
};

export default NavLink;



// WEBPACK FOOTER //
// ./components/common/navigation/NavLink.js